import React from 'react';
import { Link } from 'react-router-dom';

const LowStockAlert = ({ items = [], loading }) => {
  return (
    <div className="table-card-box">
      <div className="card-header-flex">
        <h3 className="card-title-text">Low Stock Alert</h3>
        <Link to="/admin/inventory" className="view-all-link">View All</Link>
      </div>

      <table className="custom-data-table">
        <thead>
          <tr>
            <th>Product</th>
            <th>Stock</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan={3} style={{ padding: '20px', textAlign: 'center', color: '#64748b' }}>Checking inventory...</td></tr>
          ) : !items || items.length === 0 ? (
            <tr><td colSpan={3} style={{ padding: '20px', textAlign: 'center', color: '#16a34a', fontWeight: 700 }}>✔ All panel stocks healthy!</td></tr>
          ) : (
            items.map((item) => (
              <tr key={item.id}>
                <td style={{ fontWeight: 600, color: '#0f172a' }}>{item.product}</td>
                <td style={{ fontWeight: 700 }}>{item.stock}</td>
                <td>
                  <span className={`badge-pill ${item.badge_class}`}>
                    {item.status}
                  </span>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default LowStockAlert;
